module.exports = __webpack_public_path__ + "img/overseas-service4.ef79d436.jpg";